import { useEffect } from "react";

/**
 * GoHighLevel LeadConnector Chat Widget — mounted ONLY on pages that do NOT
 * collect phone numbers / SMS opt-in (Privacy Policy, Terms of Service, etc.).
 *
 * Why: GHL compliance rule — "A form collecting phone numbers or SMS contact
 * info was detected on a page where your chat widget is embedded. Multiple
 * opt-in sources will trigger a rejection." So the widget must not coexist
 * with the contact or appointment forms on the same page.
 */
const WIDGET_ID = "6abd83532b6d9dcee817f2a7";
const LOADER_SRC = "https://widgets.leadconnectorhq.com/loader.js";
const RESOURCES_URL = "https://widgets.leadconnectorhq.com/chat-widget/loader.js";

export default function ChatWidget() {
  useEffect(() => {
    // Deferred so StrictMode's mount/unmount/mount only injects once
    const timer = setTimeout(() => {
      if (document.querySelector(`script[data-widget-id="${WIDGET_ID}"]`)) return;
      const s = document.createElement("script");
      s.src = LOADER_SRC;
      s.async = true;
      s.setAttribute("data-resources-url", RESOURCES_URL);
      s.setAttribute("data-widget-id", WIDGET_ID);
      s.setAttribute("data-source", "WEB_USER");
      document.body.appendChild(s);
    }, 0);

    return () => {
      clearTimeout(timer);
      // Clean up the injected script and any widget-rendered DOM on unmount
      document
        .querySelectorAll(`script[data-widget-id="${WIDGET_ID}"]`)
        .forEach((el) => el.remove());
      document
        .querySelectorAll(
          'chat-widget, script[src*="widgets.leadconnectorhq.com"], iframe[src*="widgets.leadconnectorhq.com"], [id^="lc-"], [class*="leadconnector"]'
        )
        .forEach((el) => el.remove());
    };
  }, []);

  return null;
}
